function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DropdownItem from "./DropdownItem";
/**
 * Custom option component that adds Bootstrap/reactstrap components and theming support to
 * https://github.com/HubSpot/react-select-plus/blob/master/src/Option.js
 */

var SelectOption =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectOption, _React$Component);

  var _super = _createSuper(SelectOption);

  function SelectOption() {
    var _this;

    _classCallCheck(this, SelectOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onFocus = function (event) {
      if (!_this.props.isFocused) {
        _this.props.onFocus(_this.props.option, event);
      }
    };

    _this.blockEvent = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    _this.handleDisabledOptionClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var anchor = event.target.closest('.Select-option a');

      if (!anchor || !('href' in anchor)) {
        return;
      }

      if (anchor.target) {
        window.open(anchor.href, anchor.target);
      } else {
        window.location.href = anchor.href;
      }
    };

    _this.handleMouseDown = function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onSelect(_this.props.option, event);
    };

    _this.handleMouseEnter = function (event) {
      return _this.onFocus(event);
    };

    _this.handleMouseMove = function (event) {
      return _this.onFocus(event);
    };

    _this.handleTouchEnd = function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;

      _this.handleMouseDown(event);
    };

    _this.handleTouchMove = function () {
      _this.dragging = true;
    };

    _this.handleTouchStart = function () {
      _this.dragging = false;
    };

    return _this;
  }

  _createClass(SelectOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          option = _this$props.option,
          instancePrefix = _this$props.instancePrefix,
          optionIndex = _this$props.optionIndex,
          isDisabled = _this$props.isDisabled,
          isFocused = _this$props.isFocused,
          isSelected = _this$props.isSelected;
      var className = classNames(this.props.className, option.className, 'text-truncate', {
        'bg-light': isSelected && !isFocused,
        'bg-primary text-white': isFocused
      });
      return option.disabled || isDisabled ?
      /*#__PURE__*/
      React.createElement(DropdownItem, {
        tag: "div" // Eliminates invalid nesting of anchors within a button (default tag)
        ,
        className: className,
        onMouseDown: this.blockEvent,
        onClick: this.handleDisabledOptionClick,
        disabled: true
      }, this.props.children) :
      /*#__PURE__*/
      React.createElement(DropdownItem, {
        className: className,
        style: option.style,
        role: "option",
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        id: "".concat(instancePrefix, "-option-").concat(optionIndex),
        title: option.title,
        "aria-selected": isSelected
      }, this.props.children);
    }
  }]);

  return SelectOption;
}(React.Component);

SelectOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  // className (based on mouse position)
  instancePrefix: PropTypes.string.isRequired,
  // unique prefix for the ids (used for aria)
  isDisabled: PropTypes.bool,
  // the option is disabled
  isFocused: PropTypes.bool,
  // the option is focused
  isSelected: PropTypes.bool,
  // the option is selected
  onFocus: PropTypes.func,
  // method to handle mouseEnter on option element
  onSelect: PropTypes.func,
  // method to handle click on option element
  option: PropTypes.object.isRequired,
  // object that is base for that option
  optionIndex: PropTypes.number // index of the option, used to generate unique ids for aria

};
SelectOption.displayName = "SelectOption";
export { SelectOption as default };